// Run the initializer only after the DOM is ready (script is loaded in <head>)
const runWhenDomReady = (init) => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, {once: true});
  } else {
    init();
  }
};

// mark page as loaded
runWhenDomReady(() => {
  document.querySelector("html").setAttribute("data-fetching","done");

  // project filters
  const filterType = document.querySelector('.filter-type');
  if (filterType) {
    const filterCategory = document.querySelector('.filter-category');
    const items = [...document.querySelectorAll('.item')];
    const noResult = document.querySelector('.no-result');
    const status = document.querySelector('.filter-status');
    const locale = document.documentElement.lang || 'de';

    const STORAGE_KEY = 'projectFilterState';

    // Texts come from the resource bundle via data attributes on .filter-status
    // (see project-list.ftl). Placeholders: {count}, {filters}.
    const text = {
      results: status?.dataset.textResults || '',
      noResults: status?.dataset.textNoResults || '',
      activeFilter: status?.dataset.textActiveFilter || ''
    };


    const state = {
      type: 'all',
      category: null
    };

    // Split the comma-separated category list of one item
    // and return clean category names without surrounding spaces.
    const getItemCategories = item =>
      item.dataset.categories
        .split(',')
        .map(category => category.trim())
        .filter(Boolean);

    // Collect all categories from all items, remove duplicates,
    // then sort them based on the current document language.
    const categories = [...new Set(items.flatMap(getItemCategories))]
      .sort((a, b) => a.localeCompare(b, locale));

    // Create one category button per unique category
    // and add it to the category filter menu.
    categories.forEach(category => {
      const li = document.createElement('li');
      li.className = 'category';

      const button = document.createElement('button');
      button.dataset.category = category;
      button.textContent = category;

      li.append(button);
      filterCategory.append(li);
    });

    function saveState() {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }

    function loadState() {
      const savedState = sessionStorage.getItem(STORAGE_KEY);
      if (!savedState) return;

      try {
        const parsedState = JSON.parse(savedState);

        const validTypes = ['all', 'ongoing', 'realized'];
        const validCategories = new Set(categories);

        state.type = validTypes.includes(parsedState.type) ? parsedState.type : 'all';
        state.category = validCategories.has(parsedState.category) ? parsedState.category : null;
      } catch {
        state.type = 'all';
        state.category = null;
      }
    }

    // Update selected state and aria-pressed for type buttons.
    function updateTypeButtons() {
      filterType.querySelectorAll('button[data-type]').forEach(button => {
        const isSelected = button.dataset.type === state.type;

        if (isSelected) {
          button.dataset.state = 'selected';
        } else {
          button.removeAttribute('data-state');
        }

        button.setAttribute('aria-pressed', String(isSelected));
      });
    }

    // Update selected state and aria-pressed for category buttons.
    function updateCategoryButtons() {
      filterCategory.querySelectorAll('button[data-category]').forEach(button => {
        const isSelected = button.dataset.category === state.category;

        if (isSelected) {
          button.dataset.state = 'selected';
        } else {
          button.removeAttribute('data-state');
        }

        button.setAttribute('aria-pressed', String(isSelected));
      });
    }

    // Disable category buttons that do not exist within the currently
    // selected type. If "all" is selected, all category buttons stay enabled.
    function updateCategoryAvailability() {
      const availableCategories = new Set();

      items.forEach(item => {
        const matchesType =
          state.type === 'all' || item.dataset.type === state.type;

        if (!matchesType) return;

        getItemCategories(item).forEach(category => {
          availableCategories.add(category);
        });
      });

      filterCategory.querySelectorAll('button[data-category]').forEach(button => {
        const isAvailable =
          state.type === 'all' || availableCategories.has(button.dataset.category);

        button.disabled = !isAvailable;
      });

      // Reset the current category if it is no longer available
      // after changing the selected type.
      if (state.category && !availableCategories.has(state.category)) {
        state.category = null;
      }
    }

    // Announce the current result count and active filters
    // through the live region for screen reader users.
    function announceResults(visibleCount) {
      if (!status) return;

      // Read the label from the button itself so that editorial changes to
      // the button text stay in sync with the announcement.
      const typeLabel =
        filterType.querySelector(`button[data-type="${state.type}"]`)?.textContent.trim() || '';

      const filters = state.category ? `${typeLabel}, ${state.category}` : typeLabel;

      const count = visibleCount
        ? text.results.replace('{count}', visibleCount)
        : text.noResults;

      const message =
        `${count} ${text.activeFilter.replace('{filters}', filters)}`.trim();

      status.textContent = '';

      requestAnimationFrame(() => {
        status.textContent = message;
      });
    }

    // Show only items that match the selected type and category.
    // Non-matching items get the inert attribute.
    // Also toggle the "no result" element when nothing matches.
    function updateItems() {
      let visibleCount = 0;

      items.forEach(item => {
        const matchesType =
          state.type === 'all' || item.dataset.type === state.type;

        const matchesCategory =
          !state.category || getItemCategories(item).includes(state.category);

        const isVisible = matchesType && matchesCategory;

        item.toggleAttribute('inert', !isVisible);

        if (isVisible) visibleCount++;
      });

      noResult?.toggleAttribute('inert', visibleCount > 0);
      announceResults(visibleCount);
    }

    // Handle clicks on type buttons.
// Clicking "all" also resets the category filter.
// Clicking the active type button resets the type filter to "all".
    filterType.addEventListener('click', event => {
      const button = event.target.closest('button[data-type]');
      if (!button) return;

      const clickedType = button.dataset.type;

      state.type =
        state.type === clickedType
          ? 'all'
          : clickedType;

      if (clickedType === 'all') {
        state.category = null;
      }

      updateTypeButtons();
      updateCategoryAvailability();
      updateCategoryButtons();
      updateItems();
      saveState();
    });

    // Handle clicks on type buttons.
    // Clicking the active type button resets the type filter to "all" but Categories stay active
    // filterType.addEventListener('click', event => {
    //   const button = event.target.closest('button[data-type]');
    //   if (!button) return;
    //
    //   state.type =
    //     state.type === button.dataset.type
    //       ? 'all'
    //       : button.dataset.type;
    //
    //   updateTypeButtons();
    //   updateCategoryAvailability();
    //   updateCategoryButtons();
    //   updateItems();
    //   saveState();
    // });

    // Handle clicks on category buttons.
    // Clicking the already selected category resets the category filter.
    filterCategory.addEventListener('click', event => {
      const button = event.target.closest('button[data-category]');
      if (!button || button.disabled) return;

      state.category =
        state.category === button.dataset.category
          ? null
          : button.dataset.category;

      updateCategoryButtons();
      updateItems();
      saveState();
    });

    // Restore saved filter state on page load.
    // Default is: type = all, category = null.
    loadState();
    updateCategoryAvailability();
    updateTypeButtons();
    updateCategoryButtons();
    updateItems();
    saveState();
  }
});